import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const LocationIcon = ({
  color, fillOpacity, ...props
}) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7.02439C14 12.2927 7 18 7 18C7 18 0 12.2927 0 7.02439C0 3.14492 3.134 0 7 0C10.866 0 14 3.14492 14 7.02439ZM10.5 7.02439C10.5 8.96409 8.93296 10.5366 7 10.5366C5.067 10.5366 3.5 8.96409 3.5 7.02439C3.5 5.08466 5.067 3.5122 7 3.5122C8.93296 3.5122 10.5 5.08466 10.5 7.02439Z"
    />
  </svg>

);

LocationIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

LocationIcon.defaultProps = {
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(14, 18),
  ...helpers.getViewBoxProperty({ width: 14, height: 18 }),
};

export default LocationIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/location.js